import { render, staticRenderFns } from "./OrderKidsV2.vue?vue&type=template&id=f347a880"
import script from "./OrderKidsV2.vue?vue&type=script&lang=js"
export * from "./OrderKidsV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f347a880')) {
      api.createRecord('f347a880', component.options)
    } else {
      api.reload('f347a880', component.options)
    }
    module.hot.accept("./OrderKidsV2.vue?vue&type=template&id=f347a880", function () {
      api.rerender('f347a880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/OrderKidsV2/OrderKidsV2.vue"
export default component.exports